<div class="forgot-password-wrapper">
  <mat-card class="forgot-password-card">
    <mat-card-header class="forgot-password-header">
      <div class="logo" role="img" aria-label="Damotech"></div>
      <div class="title">{{ 'forgotpassword.title' | translate }}</div>
      <div class="description">{{ 'forgotpassword.description' | translate }}</div>
    </mat-card-header>

    <div class="forgot-password-content">
      <mat-card-content>
        @if (successMessage()) {
          <p class="success-message">{{ successMessage() }}</p>
        } @else {
          <form [formGroup]="form" (ngSubmit)="onSubmit()">
            <div class="fields">
              <mat-form-field appearance="outline">
                <mat-label>{{ 'forgotpassword.email.title' | translate }}</mat-label>
                <input matInput type="email" formControlName="email" autocomplete="email" />
                <mat-icon matPrefix>email</mat-icon>
                @if (form.get('email')?.hasError('required') && form.get('email')?.touched) {
                  <mat-error>{{ 'forgotpassword.email.required' | translate }}</mat-error>
                } @else if (form.get('email')?.hasError('email') && form.get('email')?.touched) {
                  <mat-error>{{ 'forgotpassword.email.invalid' | translate }}</mat-error>
                }
              </mat-form-field>

              @if (errorMessage()) {
                <p class="error-message">{{ errorMessage() }}</p>
              }

              <button mat-flat-button color="primary" type="submit" class="btn" [disabled]="loading()">
                @if (loading()) {
                  <mat-spinner diameter="20" />
                } @else {
                  {{ 'forgotpassword.submit' | translate }}
                }
              </button>
            </div>
          </form>
        }
      </mat-card-content>

      <mat-card-actions class="forgot-password-actions">
        <a mat-button [routerLink]="['../', DAMO_AUTH_PATHS.SIGN_IN]" class="back-to-sign-in-link">
          {{ 'forgotpassword.backtosignin' | translate }}
        </a>
      </mat-card-actions>
    </div>
  </mat-card>
</div>
